export enum NarvarBackSyncStatus {
  Idle = "idle",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
}
